export default "__VITE_ASSET__PKn_w5iv__"